import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/index/index.vue";
import memberList from "@/views/memberList.vue";
import ProductService from "../views/zone/productService/index.vue";
Vue.use(VueRouter);

const routes = [
    {
      path:'/memberList',
      component: memberList,
    },
    // 首页
    {
        path: "/",
        name: "Index",
        component: Index,
        meta: {
            title: '首页',
            keepAlive: true, // 需要被缓存
        }
    },
    {
        path: "/login", // 会员登录
        name: "Login",
        component: () => import("../views/index/login/index.vue"),
        meta: {
            title: '会员登录',
            keepAlive: true,
        }
    },
    {
        path: "/forget", // 忘记密码
        name: "Forget",
        component: () => import("../views/index/forget/index.vue"),
        meta: {
            title: '忘记密码',
            keepAlive: true,
        }
    },
    {
        path: "/register", // 会员注册
        name: "Register",
        component: () => import("../views/index/register/index.vue"),
        meta: {
            title: '会员注册',
            keepAlive: true,
        }
    },
    {
        path: "/brief", // 协会简介
        name: "Brief",
        component: () => import("../views/about/brief/index.vue"),
        meta: {
            title: '协会简介',
            keepAlive: true,
        }
    },
    {
        path: "/rules", // 协会简章
        name: "Rules",
        component: () => import("../views/about/rules/index.vue"),
        meta: {
            title: '协会简章',
            keepAlive: true,
        }
    },
    {
        path: "/leader", // 协会领导
        name: "Leader",
        component: () => import("../views/about/leader/index.vue"),
        meta: {
            title: '协会领导',
            keepAlive: true,
        }
    },
    {
        path: "/framework", // 协会架构
        name: "Framework",
        component: () => import("../views/about/framework/index.vue"),
        meta: {
            title: '协会架构',
            keepAlive: true,
        }
    },
    {
        path: "/member", // 协会会员
        name: "Member",
        component: () => import("../views/about/member/index.vue"),
        meta: {
            title: '协会会员',
            keepAlive: true,
        }
    },
    {
        path: "/mode", // 联系方式
        name: "Mode",
        component: () => import("../views/about/mode/index.vue"),
        meta: {
            title: '联系方式',
            keepAlive: true,
        }
    },
    {
        path: "/companyList", // 产品公司列表
        name: "CompanyList",
        component: () => import("../views/product/company/index.vue"),
        meta: {
            title: '产品公司列表',
            keepAlive: true,
        }
    },
    {
        path: "/productDetail", // 产品详情
        name: "ProductDetail",
        component: () => import("../views/product/detail/index.vue"),
        meta: {
            title: '产品详情',
            keepAlive: true,
        }
    },
    {
        path: "/productList", // 产品列表
        name: "ProductList",
        component: () => import("../views/product/productList/index.vue"),
        meta: {
            title: '产品列表',
            keepAlive: true,
        }
    },
    // 协会动态
    {
        path: "/notice", // 协会公告
        name: "Notice",
        component: () => import("../views/focus/notice/index.vue"),
        meta: {
            title: '协会公告',
            keepAlive: true,
        }
    },
    {
        path: "/focus/details", // 协会公告/详情
        name: "Details",
        component: () => import("../views/focus/notice/details/index.vue"),
        meta: {
            title: '协会公告/详情',
            keepAlive: true,
        }
    },
    {
        path: "/dynamic", // 协会动态
        name: "Dynamic",
        component: () => import("../views/focus/dynamic/index.vue"),
        meta: {
            title: '协会动态',
            keepAlive: true,
        }
    },
    {
        path: "/disinfectionTraining", // 消毒知识和技能培训
        name: "DisinfectionTraining",
        component: () => import("../views/focus/DisinfectionTraining.vue"),
        meta: {
            title: '消毒知识和技能培训',
            keepAlive: true,
        }
    },
    {
        path: "/bzd", // 消毒知识和技能培训
        name: "bzd",
        component: () => import("../views/focus/buhzidao.vue"),
        meta: {
            title: '感控管理培训',
            keepAlive: true,
        }
    },
    {
    path: "/disinfectionTrainingNew", // 消毒知识和技能培训
    name: "DisinfectionTrainingNew",
    component: () => import("../views/focus/DisinfectionTrainingNew.vue"),
    meta: {
      title: '消毒产品相关培训',
      keepAlive: true,
    }
  },{
        path: "/secondaryEducation", // 继教项目
        name: "SecondaryEducation",
        component: () => import("../views/focus/secondaryEducation/index.vue"),
        meta: {
            title: '继教项目',
            keepAlive: true,
        }
    },
    {
        path: "/information", // 会员资讯
        name: "Information",
        component: () => import("../views/focus/information/index.vue"),
        meta: {
            title: '会员资讯',
            keepAlive: true,
        }
    },
    {
        path: "/associationNews", // 协会新闻
        name: "AssociationNews",
        component: () => import("../views/focus/associationNews/index.vue"),
        meta: {
            title: '协会新闻',
            keepAlive: true,
        }
    },
    // 行业资讯
    {
        path: "/law", // 国家法律
        name: "Law",
        component: () => import("../views/statute/law/index.vue"),
        meta: {
            title: '国家法律',
            keepAlive: true,
        }
    },
    {
        path: "/regulations", // 行政法规
        name: "Regulations",
        component: () => import("../views/statute/regulations/index.vue"),
        meta: {
            title: '行政法规',
            keepAlive: true,
        }
    },
    {
        path: "/standard", // 行业标准
        name: "Standard",
        component: () => import("../views/statute/standard/index.vue"),
        meta: {
            title: '行业标准',
            keepAlive: true,
        }
    },
    {
        path: "/kepu", // 科普知识
        name: "kepu",
        component: () => import("../views/statute/kepu/index.vue"),
        meta: {
            title: '科普知识',
            keepAlive: true,
        }
    },
    {
        path: "/statute/details", // 行业资讯/详情
        name: "Details",
        component: () => import("../views/statute/details/index.vue"),
        meta: {
            title: '行业资讯/详情',
            keepAlive: true,
        }
    },
    // 会员专区
    {
        path: "/file", // 通知公告
        name: "File",
        component: () => import("../views/zone/file/index.vue"),
        meta: {
            title: '通知公告',
            keepAlive: true,
        }
    },
    {
        path: "/industry", // 会员活动
        name: "Industry",
        component: () => import("../views/zone/industry/index.vue"),
        meta: {
            title: '会员活动',
            keepAlive: true,
        }
    },
    {
        path: "/industryNews", // 学习资料
        name: "IndustryNews",
        component: () => import("../views/zone/industryNews/index.vue"),
        meta: {
            title: '学习资料',
            keepAlive: true,
        }
    },
    {
        path: "/recordManagement", // 备案管理
        name: "RecordManagement",
        component: () => import("../views/zone/recordManagement/index.vue"),
        meta: {
            title: '备案管理',
            keepAlive: true,
        }
    },
    {
        path: "/memberInformation", // 会员信息
        name: "MemberInformation",
        component: () => import("../views/zone/memberInformation/index.vue"),
        meta: {
            title: '会员信息',
            keepAlive: true,
        }
    },
    {
        path: "/credit", // 信用评价
        name: "Credit",
        component: () => import("../views/zone/credit/index.vue"),
        meta: {
            title: '信用评价',
            keepAlive: true,
        }
    },
    {
        path: "/zone/details", // 会员专区/详情
        name: "Details",
        component: () => import("../views/zone/details/index.vue"),
        meta: {
            title: '会员专区/详情',
            keepAlive: true,
        }
    },
    {
        path: "/lay/detailslay", // 申请入会/详情
        name: "Details",
        component: () => import("../views/statute/law/index/index.vue"),
        meta: {
            title: '申请入会/详情',
            keepAlive: true,
        }
    },
    {
        path: "/lay/neu", // 下载中心/详情
        name: "Details",
        component: () => import("../views/statute/law/index/neu.vue"),
        meta: {
            title: '下载中心/详情',
            keepAlive: true,
        }
    },
    {
        path: "/listOf", // 消毒服务机构列表
        name: "ListOf",
        component: () => import("../views/record/listOf.vue"),
        meta: {
            title: '消毒服务机构列表',
            keepAlive: true,
        }
    },
    {
        path: "/publicityList", // 消毒检测评价机构备案公示名单列表
        name: "PublicityList",
        component: () => import("../views/record/publicityList.vue"),
        meta: {
            title: '消毒检测评价机构备案公示名单列表',
            keepAlive: true,
        }
    },
    {
        path: "/disinfectionService", // 消毒服务机构详情
        name: "DisinfectionService",
        component: () => import("../views/record/disinfectionService.vue"),
        meta: {
            title: '消毒服务机构',
            keepAlive: true,
        }
    },
    {
        path: "/record/details", // 备案流程/详情
        name: "Details",
        component: () => import("../views/record/details/index.vue"),
        meta: {
            title: '备案流程/详情',
            keepAlive: true,
        }
    },
    {
        path: "/filingProcess", // 备案流程
        name: "FilingProcess",
        component: () => import("../views/record/filingProcess.vue"),
        meta: {
            title: '备案流程',
            keepAlive: true,
        }
    }, {
        path: "/productFiling", // 产品备案
        name: "ProductFiling",
        component: () => import("../views/record/productFiling.vue"),
        meta: {
            title: '产品备案',
            keepAlive: true,
        }
    }, {
        path: "/productDetails", // 产品备案详情
        name: "ProductDetails",
        component: () => import("../views/record/details/productDetails.vue"),
        meta: {
            title: '产品备案详情',
            keepAlive: true,
        }
    },
    {
        path: "/scoreShow", // 考生成绩查询
        name: "scoreShow",
        component: () => import("../views/study/scoreShow/index.vue"),
        meta: {
            title: '考生成绩查询',
            keepAlive: true,
        }
    },
    {
        path: "/disinfectionTest", // 下载中心/详情
        name: "DisinfectionTest",
        component: () => import("../views/record/disinfectionTest.vue"),
        meta: {
            title: '消毒检测(评价)机构备案',
            keepAlive: true,
        }
    },
    {
        path: "/searchsList", // 搜索列表
        name: "SearchsList",
        component: () => import("../views/searchs/list.vue"),
        meta: {
            title: '搜索列表',
            keepAlive: true,
        }
    },
    {
        path: "/searchs", // 搜索详情
        name: "Searchs",
        component: () => import("../views/searchs/index.vue"),
        meta: {
            title: '搜索列表详情',
            keepAlive: true,
        }
    },
    // 新增产品技术服务路由
    {
        path: "/productService", // 产品技术服务
        name: "ProductService",
        component: () => import("../views/zone/productService/index.vue"),
        meta: {
            title: '产品技术服务',
            keepAlive: true,
        }
    },
    // 党建工作
    {
        path: "/workDynamics", // 工作动态
        name: "WorkDynamics",
        component: () => import("../views/partyBuilding/workDynamics/index.vue"),
        meta: {
            title: '工作动态',
            keepAlive: true,
        }
    },
    {
        path: "/studyFiles", // 学习文件
        name: "StudyFiles",
        component: () => import("../views/partyBuilding/studyFiles/index.vue"),
        meta: {
            title: '党建工作-学习文件',
            keepAlive: true,
        }
    },
    {
        path: "/partyBuilding/details", // 党建工作详情
        name: "PartyBuildingDetails",
        component: () => import("../views/partyBuilding/details/index.vue"),
        meta: {
            title: '党建工作详情',
            keepAlive: true,
        }
    }
];
const routerRePush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
    return routerRePush.call(this, location).catch(error => error)
}

const router = new VueRouter({
    // mode: "history",
    linkActiveClass: 'active',
    base: process.env.BASE_URL,
    routes
});

export default router;
